import React from 'react';
import { createColumnHelper } from '../../../Utils/ReactTable';
import Timer from '../../../Utils/Timer';
import { Button } from '../../../ds';

const columnHelper = createColumnHelper();

const tableHeaders = {
  refundDate: 'Fecha',
  refundHour: 'Hora',
  templateFile: 'Plantilla',
  total: 'Totales',
  successRefundsCount: 'Completadas',
  failedRefundsCount: 'No Completadas',
};

const BulkRefundsColumns = ({ onClick = () => null }) => [
  columnHelper.accessor('refund_date', {
    header: tableHeaders.refundDate,
    minSize: 14,
    size: 14,
    cell: props =>
      props.row.original.created_at
        ? Timer().toLocal(props.row.original.created_at, 'dd/MM/yyyy')
        : '',
  }),
  columnHelper.accessor('refund_hour', {
    header: tableHeaders.refundHour,
    minSize: 14,
    size: 14,
    cell: props =>
      props.row.original.created_at
        ? Timer().toLocal(props.row.original.created_at, 'HH:mm:ss')
        : '',
  }),
  columnHelper.accessor('total', {
    header: tableHeaders.total,
    minSize: 10,
    size: 10,
    cell: props => {
      return (
        Number(props.row.original.success_refunds_count || 0) +
        Number(props.row.original.failed_refunds_count || 0)
      );
    },
  }),
  columnHelper.accessor('success_refunds_count', {
    header: tableHeaders.successRefundsCount,
    minSize: 10,
    size: 10,
  }),
  columnHelper.accessor('failed_refunds_count', {
    header: tableHeaders.failedRefundsCount,
    minSize: 10,
    size: 10,
  }),
  columnHelper.accessor('action', {
    header: 'Acción',
    minSize: 20,
    size: 20,
    cell: props => {
      if (props.row.original.errors_file) {
        return (
          <Button
            style={{ padding: '0', fontWeight: '400' }}
            type='link'
            onClick={() => onClick(props.row.original, 'errors_file')}
            textLeft
          >
            Revisar no completadas
          </Button>
        );
      }

      return <div></div>;
    },
  }),
];

export default BulkRefundsColumns;
